"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageCategories = getImageCategories;
exports.groupHotelAmenitiesInColumns = groupHotelAmenitiesInColumns;
exports.localizedFAQList = localizedFAQList;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _range2 = _interopRequireDefault(require("lodash/range"));
var _image = require("../utils/image.utils");
var _language = require("../utils/language.utils");
var _excluded = ["images", "imageGroupId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function localizedFAQList(_ref) {
  var list = _ref.list,
    isRtl = _ref.isRtl;
  return (0, _map2["default"])(list, function (_ref2) {
    var questionAr = _ref2.questionAr,
      answerAr = _ref2.answerAr,
      questionEn = _ref2.questionEn,
      answerEn = _ref2.answerEn;
    return {
      question: isRtl ? questionAr : questionEn,
      answer: isRtl ? answerAr : answerEn
    };
  });
}
function groupHotelAmenitiesInColumns() {
  var amenities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var COLUMNS_COUNT = 4;
  return (0, _range2["default"])(COLUMNS_COUNT).map(function (colIndex) {
    return amenities.map(function (_, amenityIndex) {
      return amenities[amenityIndex * COLUMNS_COUNT + colIndex];
    }).filter(Boolean);
  });
}
function getImageCategories() {
  var imageCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var config = arguments.length > 1 ? arguments[1] : undefined;
  var isDev = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return imageCategories.reduce(function (allImages, _ref3) {
    var images = _ref3.images,
      imageGroupId = _ref3.imageGroupId,
      props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
    return [].concat((0, _toConsumableArray2["default"])(allImages), (0, _toConsumableArray2["default"])(images.map(function (img) {
      return _objectSpread(_objectSpread({
        imageGroupId: imageGroupId
      }, (0, _image.appendThumbnails)({
        img: img,
        isDev: isDev,
        isDesktop: config.isMobile === false
      })), {}, {
        description: (0, _language.translate2keysLabel)(props, 'title', config.language)
      });
    })));
  }, []);
}